import { loadCSVList } from "./csvLoader";
export const loadBloodTypes = () =>
  loadCSVList("/data/clean/blood_types.csv", { unique: true, sort: true });